import { api } from "../api";
import { validatePassword, mountPasswordChecklist } from "../utils/validation";
import { esc } from "../utils/html";

let step = 1;

// Gespeicherte Daten aus Schritt 1
let schoolData = { name: "", address: "", plz: "", ort: "", email: "" };

export async function render(el: HTMLElement) {
  step = 1;
  renderStep(el);
}

function renderStepper(): string {
  return `<div class="register-stepper">
    <div class="register-step ${step >= 1 ? "active" : ""} ${step > 1 ? "done" : ""}">
      <div class="step-number">${step > 1 ? "&#10003;" : "1"}</div>
      <div class="step-label">Organisation</div>
    </div>
    <div class="step-line ${step > 1 ? "done" : ""}"></div>
    <div class="register-step ${step >= 2 ? "active" : ""} ${step > 2 ? "done" : ""}">
      <div class="step-number">${step > 2 ? "&#10003;" : "2"}</div>
      <div class="step-label">Benutzer</div>
    </div>
    <div class="step-line ${step > 2 ? "done" : ""}"></div>
    <div class="register-step ${step >= 3 ? "active" : ""}">
      <div class="step-number">&#10003;</div>
      <div class="step-label">Fertig</div>
    </div>
  </div>`;
}

function renderStep(el: HTMLElement) {
  if (step === 1) renderStep1(el);
  else if (step === 2) renderStep2(el);
  else renderSuccess(el);
}

function renderStep1(el: HTMLElement) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung</p>
        ${renderStepper()}
        <div class="register-form">
          <h2>Organisation</h2>
          <div class="form-group"><label>Name der Schule *</label><input id="r-name" value="${esc(schoolData.name)}" placeholder="z.B. Therapieschule Berlin" /></div>
          <div class="form-group"><label>Adresse (Stra\u00dfe und Hausnummer) *</label><input id="r-address" value="${esc(schoolData.address)}" placeholder="z.B. Musterstra\u00dfe 12" /></div>
          <div class="form-grid">
            <div class="form-group"><label>PLZ *</label><input id="r-plz" value="${esc(schoolData.plz)}" maxlength="5" placeholder="12345" /></div>
            <div class="form-group"><label>Ort *</label><input id="r-ort" value="${esc(schoolData.ort)}" placeholder="Berlin" /></div>
          </div>
          <div class="form-group"><label>E-Mail der Organisation *</label><input id="r-school-email" type="email" value="${esc(schoolData.email)}" placeholder="info@schule.de" /></div>
          <div id="r-error" class="register-error hidden"></div>
          <div class="form-actions" style="justify-content:flex-end">
            <button class="btn btn-primary" id="r-next">Weiter</button>
          </div>
        </div>
        <a href="#/" class="register-back">Zur\u00fcck zur Anmeldung</a>
      </div>
    </div>`;

  el.querySelector("#r-next")!.addEventListener("click", () => {
    const name = (el.querySelector("#r-name") as HTMLInputElement).value.trim();
    const address = (el.querySelector("#r-address") as HTMLInputElement).value.trim();
    const plz = (el.querySelector("#r-plz") as HTMLInputElement).value.trim();
    const ort = (el.querySelector("#r-ort") as HTMLInputElement).value.trim();
    const email = (el.querySelector("#r-school-email") as HTMLInputElement).value.trim();

    const errEl = el.querySelector("#r-error")!;
    if (!name || !address || !plz || !ort || !email) {
      errEl.textContent = "Bitte f\u00fclle alle Pflichtfelder aus.";
      errEl.classList.remove("hidden");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errEl.textContent = "Bitte gib eine g\u00fcltige E-Mail-Adresse ein.";
      errEl.classList.remove("hidden");
      return;
    }

    schoolData = { name, address, plz, ort, email };
    step = 2;
    renderStep(el);
  });
}

function renderStep2(el: HTMLElement) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung</p>
        ${renderStepper()}
        <div class="register-form">
          <h2>Dein Benutzerkonto</h2>
          <div class="form-grid">
            <div class="form-group"><label>Vorname *</label><input id="r-firstname" placeholder="Max" /></div>
            <div class="form-group"><label>Nachname *</label><input id="r-lastname" placeholder="Mustermann" /></div>
          </div>
          <div class="form-group"><label>E-Mail-Adresse *</label><input id="r-email" type="email" placeholder="max@schule.de" /></div>
          <div class="form-group"><label>Passwort *</label><input id="r-password" type="password" /><ul id="r-pw-checklist" class="pw-checklist"></ul></div>
          <div class="form-group"><label>Passwort best\u00e4tigen *</label><input id="r-password2" type="password" /></div>
          <div class="form-group consent-group">
            <label class="checkbox-label">
              <input type="checkbox" id="r-agb">
              <span>Ich akzeptiere die <a href="#/agb" target="_blank" class="link-btn">Allgemeinen Gesch\u00e4ftsbedingungen (AGB)</a></span>
            </label>
          </div>
          <div class="form-group consent-group">
            <label class="checkbox-label">
              <input type="checkbox" id="r-avv">
              <span>Ich stimme der <a href="#/avv" target="_blank" class="link-btn">Auftragsverarbeitungsvereinbarung (AVV)</a> gem\u00e4\u00df Art.\u00a028\u00a0DS-GVO zu</span>
            </label>
          </div>
          <div id="r-error" class="register-error hidden"></div>
          <div class="form-actions">
            <button class="btn btn-secondary" id="r-back">Zur\u00fcck</button>
            <button class="btn btn-primary" id="r-submit">Registrieren</button>
          </div>
        </div>
        <a href="#/" class="register-back">Zur\u00fcck zur Anmeldung</a>
      </div>
    </div>`;

  el.querySelector("#r-back")!.addEventListener("click", () => { step = 1; renderStep(el); });
  el.querySelector("#r-submit")!.addEventListener("click", () => submitRegistration(el));
  mountPasswordChecklist(el.querySelector("#r-password")!, el.querySelector("#r-pw-checklist")!);
}

async function submitRegistration(el: HTMLElement) {
  const firstName = (el.querySelector("#r-firstname") as HTMLInputElement).value.trim();
  const lastName = (el.querySelector("#r-lastname") as HTMLInputElement).value.trim();
  const email = (el.querySelector("#r-email") as HTMLInputElement).value.trim();
  const password = (el.querySelector("#r-password") as HTMLInputElement).value;
  const password2 = (el.querySelector("#r-password2") as HTMLInputElement).value;
  const agbAccepted = (el.querySelector("#r-agb") as HTMLInputElement).checked;
  const avvAccepted = (el.querySelector("#r-avv") as HTMLInputElement).checked;

  const errEl = el.querySelector("#r-error")!;
  if (!firstName || !lastName || !email || !password) {
    errEl.textContent = "Bitte f\u00fclle alle Pflichtfelder aus.";
    errEl.classList.remove("hidden");
    return;
  }
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    errEl.textContent = "Bitte gib eine g\u00fcltige E-Mail-Adresse ein.";
    errEl.classList.remove("hidden");
    return;
  }
  const pwErr = validatePassword(password);
  if (pwErr) {
    errEl.textContent = pwErr;
    errEl.classList.remove("hidden");
    return;
  }
  if (password !== password2) {
    errEl.textContent = "Die Passw\u00f6rter stimmen nicht \u00fcberein.";
    errEl.classList.remove("hidden");
    return;
  }
  if (!agbAccepted) {
    errEl.textContent = "Bitte akzeptiere die Allgemeinen Gesch\u00e4ftsbedingungen.";
    errEl.classList.remove("hidden");
    return;
  }
  if (!avvAccepted) {
    errEl.textContent = "Bitte stimme der Auftragsverarbeitungsvereinbarung zu.";
    errEl.classList.remove("hidden");
    return;
  }

  // Loading-Zustand
  const submitBtn = el.querySelector("#r-submit") as HTMLButtonElement;
  submitBtn.disabled = true;
  submitBtn.textContent = "Wird registriert\u2026";
  errEl.classList.add("hidden");

  try {
    await api.register.submit({
      school: schoolData,
      user: { firstName, lastName, email, password },
      agbAccepted: true,
      avvAccepted: true,
    });
    step = 3;
    renderSuccess(el, email);
  } catch (err: any) {
    errEl.textContent = err.message || "Registrierung fehlgeschlagen.";
    errEl.classList.remove("hidden");
    submitBtn.disabled = false;
    submitBtn.textContent = "Registrieren";
  }
}

function renderSuccess(el: HTMLElement, email?: string) {
  el.innerHTML = `
    <div class="register-screen">
      <div class="register-card">
        <img src="Logo.png" alt="Meduvio Logo" class="login-logo">
        <h1>Meduvio</h1>
        <p class="register-subtitle">Registrierung</p>
        ${renderStepper()}
        <div class="register-form register-success">
          <div class="success-icon">&#10004;</div>
          <h2>Registrierung erfolgreich!</h2>
          <p>Beim ersten Anmelden wirst du aufgefordert, deine E-Mail-Adresse zu best\u00e4tigen.</p>
          <p>Ein Best\u00e4tigungslink wird dann an${email ? ` <strong>${esc(email)}</strong>` : " deine E-Mail-Adresse"} gesendet.</p>
          <div class="form-actions" style="justify-content:center;margin-top:1.5rem">
            <a href="#/" class="btn btn-primary">Zur Anmeldung</a>
          </div>
        </div>
      </div>
    </div>`;
}
